import styled from "styled-components";
import theme from "../../style/theme";
import CloseLineIcon from "../icons/CloseLineIcon";

interface Props {
    text: string;
    key: string;
    onClickFilterMultiSelectItem: () => void;
}

export const FilterChip: React.FC<Props> = (
    {
        text,
        key,
        onClickFilterMultiSelectItem,
    }
) => {
    return (
        <DashboardChipContainer onClick={onClickFilterMultiSelectItem}>
            <DashboardChipTitle>{text}</DashboardChipTitle>
            <RightIconWrapper>
                <CloseLineIcon
                    fill={theme.palette.primitives.yellow500}
                    style={{ width: 12, height: 12 }}
                />
            </RightIconWrapper>
        </DashboardChipContainer>
    );
};

const DashboardChipContainer = styled.div`
  height: 27px;
  display: flex;
  flex-direction: row;
  align-items: center;
  border-radius: 4px;
  padding: 0 8px;
  gap: 4px;
  flex-shrink: 0;
  background-color: ${theme.palette.primitives.yellow200};
  margin: 0 4px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  border: 1px solid transparent;
  
  &:hover {
    background-color: ${theme.palette.primitives.yellow300};
    border-color: ${theme.palette.primitives.yellow400};
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  }

  &:active {
    transform: translateY(0);
    box-shadow: none;
  }
`;
const DashboardChipTitle = styled.div`
  font-size: 13px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  color: ${theme.palette.primitives.yellow700};
`;

const RightIconWrapper = styled.div``;
